import Index from '../../pages/hjwq/prebook/index'
import Query from '../../pages/hjwq/prebook/query'

const base = 'prebook'

const routes = [
    {
        path: `/${base}/index`,
        name: `${base}-index`,
        component: Index
    },
    {
        path: `/${base}/enter*`,
        name: `${base}-enter`,
        component: Index
    },
    {
        path: `/${base}/query*`,
        name: `${base}-query`,
        component: Query
    }
]

export default routes



// WEBPACK FOOTER //
// ./src/router/hjwq/prebook.js